module.exports = "<div class=\"text-center\">\r\n    <h6 class=\"m-0 pb-1\" style=\"white-space: pre-wrap; line-height: 1.4;\">{{ title }}</h6>\r\n    <div md-dialog-content>\r\n        <md-spinner [style.margin]=\"'auto'\"></md-spinner>\r\n        <div style=\"position:relative; top: -60px; left: 0px;font-weight:bold;\">{{percentage}}</div>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/services/app-loader/app-loader.component.html
// module id = 1104
// module chunks = 1